import {AdminRuntimeEnvProfile} from '../enum/AdminRuntimeEnvProfile'
import {IAdminRuntimeState} from '../types/IAdminRuntimeState'

export const DefaultAdminRuntimeState: IAdminRuntimeState = {
  godMode: false,
  profile: AdminRuntimeEnvProfile.Inherit,
  overrides: {},
}
